/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

/*Sentry.init({
  dsn: "https://3ec2560cfbf74fe2a06457aca04dfc35@o4505120325369856.ingest.sentry.io/4505120326549504",
  integrations: [
    // Registers and configures the Tracing integration,
    // which automatically instruments your application to monitor its
    // performance, including custom Angular routing instrumentation
    new Sentry.BrowserTracing({
      // tracePropagationTargets: ["localhost", "https://yourserver.io/api"],
      routingInstrumentation: Sentry.routingInstrumentation
    }),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});*/

if (environment.production) {
  enableProdMode();
}

const DEV_SW_RELOAD_KEY = 'salute-con-te:dev-sw-cleanup';

function isAngularServiceWorker(worker: ServiceWorker | null): boolean {
  if (!worker) {
    return false;
  }

  try {
    return new URL(worker.scriptURL).pathname.endsWith('/ngsw-worker.js');
  } catch {
    return false;
  }
}

/**
 * A service worker già installato continua a controllare localhost anche se la
 * nuova build non lo registra più. In sviluppo lo rimuoviamo prima del bootstrap
 * e ricarichiamo una sola volta la pagina, così ng serve torna a gestire il reload.
 */
async function prepareDevelopmentMode(): Promise<boolean> {
  if (environment.config.pwa.enabled || !('serviceWorker' in navigator)) {
    return true;
  }

  try {
    const wasControlledByAngular = isAngularServiceWorker(navigator.serviceWorker.controller);
    const registrations = await navigator.serviceWorker.getRegistrations();
    const angularRegistrations = registrations.filter(registration =>
      [registration.active, registration.waiting, registration.installing]
        .some(worker => isAngularServiceWorker(worker))
    );

    await Promise.all(angularRegistrations.map(registration => registration.unregister()));

    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(
        cacheNames
          .filter(cacheName => cacheName.startsWith('ngsw:'))
          .map(cacheName => caches.delete(cacheName))
      );
    }

    if (wasControlledByAngular && !sessionStorage.getItem(DEV_SW_RELOAD_KEY)) {
      sessionStorage.setItem(DEV_SW_RELOAD_KEY, '1');
      location.reload();
      return false;
    }

    sessionStorage.removeItem(DEV_SW_RELOAD_KEY);
  } catch (error) {
    console.warn('Impossibile rimuovere il service worker Angular in sviluppo.', error);
  }

  return true;
}

prepareDevelopmentMode().then(shouldBootstrap => {
  if (!shouldBootstrap) {
    return;
  }

  bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.error(err));
});
